/** Matches --navbar-morph-duration in navbar.css */
export const BROWSE_CHROME_MORPH_MS = 360;

/** @type {{ scrollY: number, chromeBottom: number, enteringCompact: boolean } | null} */
let pendingMorphAnchor = null;

let morphLockedUntil = 0;

/** Bottom edge of the sticky browse filter shell (viewport px). */
export function measureBrowseChromeBottom() {
    const shell = document.querySelector('.browse-chrome-sticky');
    if (!shell) {
        return 0;
    }
    return shell.getBoundingClientRect().bottom;
}

/** Call immediately before toggling `browse-chrome-compact`. */
export function stageBrowseChromeMorphAnchor(enteringCompact) {
    pendingMorphAnchor = {
        scrollY: window.scrollY || document.documentElement.scrollTop || 0,
        chromeBottom: measureBrowseChromeBottom(),
        enteringCompact: Boolean(enteringCompact),
    };
}

/** @returns {{ scrollY: number, chromeBottom: number, enteringCompact: boolean } | null} */
export function takeBrowseChromeMorphAnchor() {
    const anchor = pendingMorphAnchor;
    pendingMorphAnchor = null;
    return anchor;
}

export function lockBrowseChromeMorph() {
    morphLockedUntil = Date.now() + BROWSE_CHROME_MORPH_MS;
}

export function unlockBrowseChromeMorph() {
    morphLockedUntil = 0;
}

export function isBrowseChromeMorphLocked() {
    return Date.now() < morphLockedUntil;
}

/**
 * After compact toggles, layout height can shift. Browse desktop chrome is fixed
 * out of flow so scroll position should not be programmatically adjusted.
 * @param {{ scrollY: number, chromeBottom: number, enteringCompact?: boolean }} _anchor
 */
export function compensateBrowseChromeMorph(_anchor) {
    /* Intentionally no scrollTo — wheel / trackpad input fights programmatic scroll */
}
